import { render, staticRenderFns } from "./MoveRight.vue?vue&type=template&id=dbfc3c58"
import script from "./MoveRight.vue?vue&type=script&lang=js"
export * from "./MoveRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports